// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"809":"c5636667f8f47440","7368":"9288aac0741377ad","8719":"3f2a51f542c1ee63"}[chunkId] + ".js";
};